import { render, staticRenderFns } from "./MemberCategory.vue?vue&type=template&id=0636042c&scoped=true&"
import script from "./MemberCategory.vue?vue&type=script&lang=js&"
export * from "./MemberCategory.vue?vue&type=script&lang=js&"
import style0 from "./MemberCategory.vue?vue&type=style&index=0&id=0636042c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0636042c",
  null
  
)

export default component.exports